module.exports = __webpack_public_path__ + "static/media/bg-image-25.ddae3beb.jpg";